import { render, staticRenderFns } from "./SidebarNotificationPanel.vue?vue&type=template&id=e8b46224&scoped=true"
import script from "./SidebarNotificationPanel.vue?vue&type=script&lang=js"
export * from "./SidebarNotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./SidebarNotificationPanel.vue?vue&type=style&index=0&id=e8b46224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b46224",
  null
  
)

export default component.exports